import "js-info-bubble";
import "gmaps-marker-clusterer";
import { Loader } from "@googlemaps/js-api-loader";
import Common from "../modules/common";

const templatePortfolio = {
  init: function () {
    templatePortfolio.locations.init();

    templatePortfolio.partners();
  },

  locations: {
    el: $("#google-map"),

    init: function () {
      if (this.el.length) {
        const loader = new Loader({
          apiKey: gmap_api_key,
          version: "weekly",
        });

        loader.load().then((google) => {
          templatePortfolio.locations.render_map();
        });
      }
    },

    render_map: function () {
      var map_options = {
        zoom: 30,
        center: {
          lat: 56.960862,
          lng: 24.105513,
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff" }, { lightness: 17 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 18 }],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 16 }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#dedede" }, { lightness: 21 }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              { visibility: "on" },
              { color: "#ffffff" },
              { lightness: 16 },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              { saturation: 36 },
              { color: "#333333" },
              { lightness: 40 },
            ],
          },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#fefefe" }, { lightness: 20 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
          },
        ],
      };
      var map = new google.maps.Map(templatePortfolio.locations.el[0], map_options);

      var post_type = templatePortfolio.locations.el.data("post-type");

      var icon = {
        path: "M22.5,58.487Q45,34.926,45,22.5a22.5,22.5,0,1,0-45,0Q0,34.926,22.5,58.487Z",
        fillColor: templatePortfolio.locations.el.data("color"),
        fillOpacity: 1,
        anchor: new google.maps.Point(18, 47),
        strokeWeight: 0,
        scale: 0.8,
      };

      $.ajax({
        url: ajaxurl,
        type: "POST",
        dataType: "JSON",
        data: {
          action: "get_locations",
          post_type: post_type,
        },
        beforeSend: function (xhr) {},
        success: function (response) {
          var i;
          var bounds = new google.maps.LatLngBounds();

          // Add some markers to the map.
          // Note: The code uses the JavaScript Array.prototype.map() method to
          // create an array of markers based on a given "locations" array.
          // The map() method here has nothing to do with the Google Maps API.
          var activeBubble = -1;
          var markers = response.map(function (data, i) {
            var location = new google.maps.LatLng(data.lat, data.lng);

            var marker = new google.maps.Marker({
              position: location,
              map: map,
              draggable: false,
              icon: icon,
              animation: google.maps.Animation.DROP,
            });

            bounds.extend(location);

            var infoBubble = new InfoBubble({
              content: data.html,
              arrowSize: 0,
              arrowPosition: 0,
              arrowStyle: 0,
              shadowStyle: 0,
              padding: 0,
              borderRadius: 0,
              borderWidth: 0,
              backgroundClassName: "google__popup",
              backgroundColor: "transparent",
              maxWidth: 390,
              minWidth: 390,
              closeSrc: templatePortfolio.locations.el.data("close"),
            });

            marker.addListener("click", function () {
              if (activeBubble != -1) activeBubble.close();
              activeBubble = infoBubble;
              infoBubble.open(map, marker);
            });

            i++;

            return marker;
          });

          map.fitBounds(bounds);

          // Add a marker clusterer to manage the markers.
          var markerCluster = new MarkerClusterer(map, markers, {
            cssClass: "cluster-icon",
          });
        },
      });
    },
  },

  partners: function () {
    var slider = $(".partners__slider");
    if (slider.length) {
      $(".partners__slider").slick({
        rows: 0,
        slidesToShow: 4,
        prevArrow: Common.prev_arrow,
        nextArrow: Common.next_arrow,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  },
};

export default templatePortfolio;
